import { Paper, Grid2, Typography, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton, Tooltip  } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';
import moment from 'moment';
import Cookies from 'js-cookie';
import { makeStyles } from '@mui/styles';

// componentes
import MiTabla from '../../../components/plantilla/tabla/MiTabla'
import useMediaQuery from '@mui/material/useMediaQuery';
import BtnAcciones from '../../../components/plantilla/tabla/BtnAcciones';

// iconos
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ModalIncidencias from './modales/ModalIncidencias';
import InformacionDrawer from './components/InformacionDrawer';
import PreviewIcon from '@mui/icons-material/Preview';
import CommentIcon from '@mui/icons-material/Comment';
import ComentariosDialog from './components/ComentariosDialog';
import HelpIcon from '@mui/icons-material/Help';

import manualDeIncidencias from '../../../docs/Manual de incidencias.pdf';

function IncidenciasMonitoreo() {

    const useStyles = makeStyles({
        visto: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
            },
        },
        resuelto: {
            backgroundColor: 'rgba(0, 255, 0, 0.1)',
            '&:hover': {
                backgroundColor: 'rgba(0, 255, 0, 0.2)',
            },
        }
    });

    const classes = useStyles();

    const isNonMobile = useMediaQuery("(min-width:600px)");

    const [dataInicidencias, setDataInicidencias] = useState([]);
    const [selectedInicidencia, setSelectedInicidencia] = useState({});
    const [modalIncidenciasOpen, setModalInicidenciasOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [catalogoIncidencias, setCatalogoIncidencias] = useState([]);
    const [isCapacitor, setIsCapacitor] = useState(false);
    const [dataCapacitador, setDataCapacitador] = useState([]);
    const [catalogoCapacitadores, setCatalogoCapacitadores] = useState([]);

    const obtenerCatalogoIncidencias = async () => {
        try {
            let response = await myApi.get('/monitoreo/incidencias/getCatalogoIncidencias');

            setCatalogoIncidencias(response.data.data);

        } catch (error) {
            console.error('Error al obtener el catalogo de incidencias:', error);
        }
    };

    useEffect(() => {

        verificarCapacitor();

        fetchIncidencias();
    }, []);

    useEffect(() => {
        obtenerCapacitadores();
    }, [catalogoIncidencias]);

    useEffect(() => {
        if (isCapacitor) {
            fetchDataCapacitador();
        }
        obtenerCatalogoIncidencias();

    }, [isCapacitor]);

    const verificarCapacitor = async () => {
        const esCapacitor = Cookies.get('ebt_perfil') == 3;
        setIsCapacitor(esCapacitor);
        if (esCapacitor) {
            fetchDataCapacitador();
        }
    };

    const obtenerCapacitadores = async () => {
        try {
            let response = await myApi.get('/monitoreo/incidencias/getCapacitadores');

            setCatalogoCapacitadores(response.data.data);
        } catch (error) {
            console.error('Error al obtener los capacitadores:', error);
        }
    };
    /*=============================================
    =            Columnas de la tabla             =
    =============================================*/
    const columns = [
        {
            field: 'fechaHora_Inicio', headerName: 'Fecha y Hora Inicio', headerAlign: "center",
            align: "center",
            width: 200,
        },
        {
            field: 'fechaHora_Fin', headerName: 'Fecha y Hora Fin', headerAlign: "center",
            align: "center",
            width: 200,
        },
        {
            field: 'camion', headerName: 'Camión', headerAlign: "center",
            align: "center",
            width: 100,
        },
        {
            field: 'operador', headerName: 'Operador', headerAlign: "center",
            align: "center",
            width: 100,
        },
        {
            field: 'fleet', headerName: 'Fleet', headerAlign: "center",
            align: "center",
            width: 100,
        },
        {
            field: 'cargado_vacio', headerName: 'Cargado/Vacio', headerAlign: "center",
            align: "center",
            width: 120,
            valueFormatter: (value) => {
                if (value == 1) {
                    return 'Yes';
                } else {
                    return 'No';
                }
            },
        },
        {
            field: 'descripcionIncidencia', headerName: 'Incidencia', headerAlign: "center",
            align: "center",
            width: 300,
        },
        {
            field: 'cliente', headerName: 'Cliente', headerAlign: "center",
            align: "center",
            width: 300,
        },
        {
            field: 'nombre_monitorista', headerName: 'Monitorista', headerAlign: "center",
            align: "center",
            width: 100,
        },
        {
            field: 'nombre_asignado', headerName: 'Asignado:', headerAlign: "center",
            align: "center",
            width: 100,
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            type: 'actions',
            width: 100,
            getActions: (params) => [
                <BtnAcciones
                    icon={<BorderColorIcon />}
                    label="Editar"
                    onClick={() => handleEdit(params.row)}
                />,
                <BtnAcciones
                    icon={<CommentIcon />}
                    label="Comentarios"
                    onClick={() => handleComentarios(params.row)}
                />
            ],
        }

    ];

    /*=============================================
    =    FUNCION PARA MANEJAR EL MODAL            =
    =============================================*/
    const handleOpenModal = (incidencias) => {
        setSelectedInicidencia(incidencias);
        setIsEditing(!!incidencias);
        setModalInicidenciasOpen(true);
    };

    const handleEdit = async (Row) => {
        setIsEditing(true);
        setSelectedInicidencia(Row);
        await obtenerCatalogoIncidencias();
        const inputOptions = catalogoIncidencias.reduce((options, incidencia) => {
            options[incidencia.value] = incidencia.label;
            return options;
        }, {});

        const { value: incidencia } = await Swal.fire({
            title: "Editar Incidencia",
            input: "select",
            inputOptions: inputOptions,
            inputPlaceholder: "Selecciona la incidencia",
            showCancelButton: true,
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    if (value) {
                        resolve();
                    } else {
                        resolve('Debes seleccionar una incidencia');
                    }
                });
            }
        });

        if (incidencia) {
            let payload = {
                id: Row.id,
                incidencia: incidencia
            };
            try {
                let updateResponse = await myApi.put('/monitoreo/incidencias/actualizarIncidencia', payload);
                if (updateResponse.data.success) {
                    Swal.fire('Incidencia actualizada', '', 'success');
                    await fetchIncidencias();
                } else {
                    Swal.fire('Error al actualizar la incidencia', '', 'error');
                }
            } catch (error) {
                console.error('Error al actualizar la incidencia:', error);
                Swal.fire('Error al actualizar la incidencia', '', 'error');
            }
        }
    };

    /*=============================================
    =            fetch incidencias                =
    =============================================*/
    const fetchIncidencias = async () => {
        try {
            const response = await myApi.get('/monitoreo/incidencias/getIncidencias');
            const data = response.data.data.map(incidencia => ({
                ...incidencia,
                fechaHora_Inicio: moment(incidencia.fechaHora_Inicio).format('DD/MM/YYYY HH:mm:ss'),
                fechaHora_Fin: moment(incidencia.fechaHora_Fin).format('DD/MM/YYYY HH:mm:ss'),
            }));

            setDataInicidencias(data);
        } catch (error) {
            console.error('Error fetching incidencias:', error);
        }
    };
    //#region VISTA CAPACITADOR
    /*=============================================
    SECCION CAPACITADOR
    =============================================*/
    const [openInfoDrawer, setOpenInfoDrawer] = useState(false);
    const [openDialogResolver, setOpenDialogResolver] = useState(false);
    const [rowInfoDrawer, setRowInfoDrawer] = useState({});
    const [selectedRow, setSelectedRow] = useState({});
    const [selectCommentRow, setSelectCommentRow] = useState({});
    const [openComentariosDialog, setOpenComentariosDialog] = useState(false);
    const columnsCapacitador = [
        {
            field: 'fechaHora_Inicio', headerName: 'Fecha y Hora Inicio', headerAlign: "center",
            align: "center", flex: 1
        },
        {
            field: 'descripcionIncidencia', headerName: 'Incidencia', headerAlign: "center",
            align: "center", flex: 1
        },
        {
            field: 'operador', headerName: 'Operador', headerAlign: "center", align: "center", flex: 1
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            type: 'actions',
            width: 100,
            getActions: (params) => [
                <BtnAcciones
                    icon={<PreviewIcon />}
                    label="Ver Detalles"
                    onClick={() => handleDetalles(params.row)}
                />,
                <BtnAcciones
                    icon={<CommentIcon />}
                    label="Comentarios"
                    onClick={() => handleComentarios(params.row)}
                />
            ],
        }
    ];

    /*=============================================
    FUNCION PARA DESPLEGAR MAS DETALLES DE LA INCIDENCIA
    =============================================*/
    const handleDetalles = async (Row) => {
        setOpenInfoDrawer(true);
        setRowInfoDrawer(Row);
        if (Row.visto == 0) {
            let response = await myApi.put(`/monitoreo/incidencias/actualizarVisto/${Row.id}`)
            console.log('response:', response.data.success);
            if (response.data.success) {
                fetchDataCapacitador();
            }
        }
        

    };

    /*=============================================
    FUNCION QUE DESPLIEGA EL DRAWER
    =============================================*/
    const togleDrawer = (bandera) =>{
        setOpenInfoDrawer(bandera);
    }

    /*=============================================
    DATOS DEL CAPACITADOR
    =============================================*/

    const fetchDataCapacitador = async () => {
        let capacitador = Cookies.get('ebt_id_user');
        try {
            const response = await myApi.get(`/monitoreo/incidencias/getIncidenciasCapacitador/${capacitador}`);
            const data = response.data.data;
            setDataCapacitador(data);
        } catch (error) {
            console.error('Error fetching incidencias:', error);
        }
    };

    /*=============================================
    FUNCIONES QUE MANEJAN EL DIALOGO DE RESOLVER INCIDENCIA
    =============================================*/
    const handleClickOpenDialogResolver = (row) => {
        setSelectedRow(row);
        setOpenDialogResolver(true);
        fetchIncidencias();
        
    };

    const handleCloseDialogResolver = () => {
        setOpenDialogResolver(false);
        setSelectedRow({});
    };

    /*=============================================
    FUNCION QUE RENDERIZA EL DIALOG DE RESOLVER INCIDENCIA
    =============================================*/
    const renderDialog = () => (
        <Dialog open={openDialogResolver} onClose={handleCloseDialogResolver}>
            <DialogTitle>Resolver Incidencia</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    ¿Estás seguro de que deseas resolver esta incidencia?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialogResolver} color="error" variant='outlined'>
                    Cancelar
                </Button>
                <Button onClick={handleConfirm} color="success" variant='contained'>
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );

    const handleConfirm = async () => {
        // Aquí puedes agregar la lógica para resolver la incidencia
        console.log('Resolviendo incidencia para la fila:', selectedRow);

        let response = await myApi.put(`/monitoreo/incidencias/resolverIncidencia/${selectedRow.id}`);

        if (response.data.success) {
            handleCloseDialogResolver();
            togleDrawer(false);
        }   
    };


    const handleComentarios = (row) => {
        setSelectCommentRow(row);
        setOpenComentariosDialog(true);
    };
    //#endregion

    const openPDFAyuda = () => {
        window.open(manualDeIncidencias, '_blank');
    };

    return (
        <Paper sx={{ padding: 2 }} elevation={2}>
            <Grid2 container>
                <Grid2 size={{ xs: 11, md: 11 }}>
                    <Typography variant="h4" fontWeight="bold" marginBottom={2}>
                        Incidencias
                    </Typography>
                </Grid2>

                <Grid2 size={{ xs: 1, md: 1 }}>
                    <Tooltip title="Ayuda">
                        <IconButton aria-label="help" onClick={openPDFAyuda}>
                            <HelpIcon />
                        </IconButton>
                    </Tooltip>
                </Grid2>

                <Grid2 size={{ xs: 12, md: 12 }}
                    sx={{
                        display: 'flex',
                        justifyContent: isNonMobile ? 'flex-end' : 'start'
                    }}>
                    {!isCapacitor && (
                        <Button
                            variant="contained"
                            startIcon={<AddCircleIcon />}
                            onClick={() => handleOpenModal()}
                            sx={{ backgroundColor: 'black', marginBottom: 1 }}
                        >
                            Agregar Incidencia
                        </Button>
                    )}
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                    <MiTabla
                        columns={isCapacitor ? columnsCapacitador : columns}
                        data={isCapacitor ? dataCapacitador : dataInicidencias}
                        getRowClassName={(params) => {
                            // Verifica si la fila tiene el valor `visto` igual a 1
                            switch (true) {
                                case params.row.visto == 1 && params.row.estado_incidencia == "pendiente":
                                    return classes.visto;
                                case params.row.visto == 1 && params.row.estado_incidencia == "resuelta":
                                    return classes.resuelto;
                                default:
                                    return '';
                            }
                            //return params.row.visto === 1 ? classes.visto : '';
                        }}
                    />
                </Grid2>
                <ModalIncidencias
                    open={modalIncidenciasOpen}
                    onClose={() => setModalInicidenciasOpen(false)}
                    incidencia={selectedInicidencia}
                    catCapacitadores={catalogoCapacitadores}
                    catIncidencias={catalogoIncidencias}
                    isEditing={isEditing}
                    refresh={fetchIncidencias}
                    dataInicidencias={dataInicidencias}
                />
                <InformacionDrawer
                    open={openInfoDrawer}
                    onClose={() => togleDrawer(false)}
                    data={rowInfoDrawer}
                    onResolve={() => handleClickOpenDialogResolver(rowInfoDrawer)}
                />

                <ComentariosDialog
                    open={openComentariosDialog}
                    onClose={() => setOpenComentariosDialog(false)}
                    incidencia={selectCommentRow}
                    usuario={Cookies.get('ebt_id_user')}
                />

                {renderDialog()}
            </Grid2>
        </Paper>
    )
}

export default IncidenciasMonitoreo